import { useCallback, useEffect, useState, type ReactNode } from "react";
import { ProfileFilterContext } from "./profile-filter-context";
// @ts-expect-error pure js
import useAuth from "../hooks/use-auth.js";

const STORAGE_PREFIX = "qalimo.profileFilter";

function storageKey(userId: number | string | undefined | null): string | null {
  if (userId === undefined || userId === null || userId === "") return null;
  return `${STORAGE_PREFIX}.${userId}`;
}

function readSelectedIds(userId: number | string | undefined | null): number[] {
  const key = storageKey(userId);
  if (!key) return [];
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id): id is number => typeof id === "number");
  } catch {
    return [];
  }
}

export default function ProfileFilterProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { auth } = useAuth();
  const userId = auth?.userId;
  const [selectedProfileIds, setSelectedProfileIdsState] = useState<number[]>(
    () => readSelectedIds(userId),
  );

  useEffect(() => {
    setSelectedProfileIdsState(readSelectedIds(userId));
  }, [userId]);

  const setSelectedProfileIds = useCallback(
    (ids: number[]) => {
      setSelectedProfileIdsState(ids);
      const key = storageKey(userId);
      if (key) {
        localStorage.setItem(key, JSON.stringify(ids));
      }
    },
    [userId],
  );

  return (
    <ProfileFilterContext.Provider
      value={{ selectedProfileIds, setSelectedProfileIds }}
    >
      {children}
    </ProfileFilterContext.Provider>
  );
}
